import bpm from "assets/images/logos/bpm.png";
import cinema from "assets/images/logos/cinema.png";
import jeru from "assets/images/logos/jeru.png";
import keter from "assets/images/logos/keter.png";
import mandel from "assets/images/logos/mandel.png";
import mccan from "assets/images/logos/mccan.png";
import netafim from "assets/images/logos/netafim.png";
import partner from "assets/images/logos/partner.png";
import uni from "assets/images/logos/uni.png";

const logos = [
  { src: bpm, alt: "BPM" },
  { src: cinema, alt: "Cinema" },
  { src: jeru, alt: "Jerusalem" },
  { src: keter, alt: "Keter" },
  { src: mandel, alt: "Mandel" },
  { src: mccan, alt: "McCann" },
  { src: netafim, alt: "Netafim" },
  { src: partner, alt: "Partner" },
  { src: uni, alt: "University" },
];

const TrustedBy = () => (
  <div className="mt-5 text-center max-w-[90%]">
    <h2 className="text-white text-3xl font-title font-extrabold mb-6 uppercase tracking-wide">
      Trusted by Leading Brands:
    </h2>
    <div className="flex justify-center flex-wrap gap-8">
      {logos.map((logo, index) => (
        <img
          key={index}
          src={logo.src}
          alt={logo.alt}
          className="h-10 md:h-16 lg:h-20 object-contain"
        />
      ))}
    </div>
  </div>
);

export default TrustedBy;
